'use strict';

angular.module('mean.trades').controller('TradeBidWizardController', ['$scope', '$timeout', 'Global', 'Bids', 'Customers', '$q', 'Users', 'MeanUser', 'toaster', 'GeneralTasks', 'Subtasks', 'Materials', 'Units', 'Equipments', '$location', 'NotifyService', 'Trades', '$filter', 'Contractors', 'daysDifferenceService', 'userService', 'bidQueryService', 'contractorQueryService', 'contactService', 'builderService', 'bidService', 'TradeBids', 'tradeCodeService', 'BidWizardEdit', 'bidPlanCodeService', 'Options', 'CombinationService',
  function($scope, $timeout, Global, Bids, Customers, $q, Users, MeanUser, toaster, GeneralTasks, Subtasks, Materials, Units, Equipments, $location, NotifyService, Trades, $filter, Contractors, daysDifferenceService, userService, bidQueryService, contractorQueryService, contactService, builderService, bidService, TradeBids, tradeCodeService, BidWizardEdit, bidPlanCodeService, Options, CombinationService) {
    $scope.global = Global;

    $scope.tasks = [];
    $scope.subtasks = [];
    $scope.saved_bid_trades = [];
    $scope.trades = tradeCodeService.getArray();
    $scope.selectedTrade = [];
    $scope.trade = {};
    $scope.bid_menu = [];
    $scope.bids = [];
    $scope.new_bids = [];
    $scope.plans = [];
    $scope.options = [];
    $scope.combOptions = [];
    $scope.combinationType = '';
    $scope.options_created = false;
    $scope.customers = [];
    $scope.selCustomer = '';
    $scope.selManager = '';
    $scope.selPAgent = '';

    $scope.user = MeanUser.user;
    daysDifferenceService.setHolidaysArray($scope.user.username);
    $scope.trades = $filter('filter')($scope.trades, {
        'name': $scope.user.trade[0] }, true);

    $scope.bid = {};
    $scope.bid.options = [];

    $scope.is_admin = userService.isAdmin($scope.user);

    if(!$scope.is_admin) {
        alert('You do not have permissions to view this page.  Contact Admin');
        return;
    }

    $scope.inList = function(item) {
        if(!$scope.bid.bidding_trades) return false;

        var inlist = $filter('filter')($scope.bid.bidding_trades, {'trade': item.name}, true);
        return inlist.length;
    };

    $scope.setTrades = function() {
        $scope.selectedTrade = $scope.bid.bidding_trades;
    };

    $scope.importPAgent = function(selPAgent) {
        if (!selPAgent) return;
        const selCust  = $scope.bid.selCustomer.contacts.purchasingAgents.filter(item => item.name === selPAgent);
        if(selCust.length) {
            $scope.bid['purchasing_agent_info'] = {};
            $scope.bid['purchasing_agent_info']['name'] = selCust[0].name;
            $scope.bid['purchasing_agent_info']['phone'] = selCust[0].phone;
            $scope.bid['purchasing_agent_info']['email'] = selCust[0].email;
        }
    }

    $scope.importProjectManager = function(selManager) {
        if (!selManager) return;
        const selCust  = $scope.bid.selCustomer.contacts.projectManagers.filter(item => item.name === selManager);
        if(selCust.length) {
            $scope.bid['project_manager_info'] = {};
            $scope.bid['project_manager_info']['name'] = selCust[0].name;
            $scope.bid['project_manager_info']['phone'] = selCust[0].phone;
            $scope.bid['project_manager_info']['email'] = selCust[0].email;
        }
    }

    $scope.importCustomer = function(selCustomer) {
        if (!selCustomer) return;
        const selCust  = $scope.customers.filter(item => item.name === selCustomer);
        if(selCust.length) {
            $scope.bid.selCustomer = selCust[0];
            $scope.bid['builder_info'] = {};
            $scope.bid['builder_info']['address_one'] = selCust[0].address.street;
            $scope.bid['builder_info']['city'] = selCust[0].address.city;
            $scope.bid['builder_info']['email'] = selCust[0].email;
            $scope.bid['builder_info']['name'] = selCust[0].name;
            $scope.bid['builder_info']['phone'] = selCust[0].phone;
            $scope.bid['builder_info']['state'] = selCust[0].address.state;
            $scope.bid['builder_info']['zip'] = selCust[0].address.zipCode;
            $scope.bid['builder_info']['address_two'] = '';
        }
    }

    userService.getMainAccountId($scope.user.username).then(function(result) {
        $scope.main_account_id = result;
        Trades.query({'main_account_id': result}, function(trades) {
            $scope.trade = trades[0];
            $scope.builder = trades[0];

            var path = $location.path();
            var value = path.split('/');
            var bid_view = value[2];

            bidQueryService.getNamesOnlyForTrade($scope.trade._id).then(function(results) {
                $scope.bids = results;
                $scope.new_bids = $filter('filter')(results, {'bid_status': 'new'}, true);
            });
        });
    });

    $scope.managers = [];
    $scope.admin_users = [];
    $scope.foreman_users = [];

    Users.query({'trade': $scope.user.trade[0], 
        'contractor_code': $scope.user.contractor_code}, function(users) {
        _.each(users, function(user) {
            if (user.roles[0] === 'tm_admin') {
                $scope.admin_users.push(user);
            } else if (user.roles[0] === 'tm_office') {
                $scope.admin_users.push(user);
            } else if (user.roles[0] === 'tm') {
                $scope.managers.push(user);
            } else if (user.roles[0] === 'foreman') {
                $scope.foreman_users.push(user);
            } 
        })
    });

    $scope.minDate = new Date();

    $scope.dateOptions = {
        dateDisabled: disabled,
        formatYear: 'yy',
        startingDay: 0,
        minDate: new Date(),
        showWeeks: false
    };

    $scope.open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.opened = true;
    };

    $scope.start_open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.start_opened = true;
    };

    // All data will be store in this object
    $scope.suppliers = [];
    $scope.equipment_suppliers = [];

    $scope.init = function() {
        $scope.editId = 1;console.log('init');
        Users.query({ username: $scope.user.username }, function (result) {
            if (result.length) {
                result[0].combination.forEach(item => {
                    $scope.combOptions.push({
                        'label': item.label,
                        'type': item.type,
                        'location': item.location,
                        'isCustom': item.isCustom || false,
                        'userId': item.userId || ''
                    });
                });
            }
        }); 
    };

    function disabled(data) {
        return daysDifferenceService.disabled(data.date, data.mode);
    };

    $scope.addBid = function() {
        if (!$scope.new_bid_name) return;

        var bid = new Bids({
            bid_name: $scope.new_bid_name,
            bid_status: 'new',
            trade_id: $scope.trade._id
            //contractor: $scope.mtc._id
        });

        bid.$save(function(response) {
            response.bid_date_requested = new Date(response.bid_date_requested);
            response.project_start_date = new Date(response.project_start_date);
            $scope.new_bids.push(response);

            $scope.new_bid_name = '';
            $scope.bid = response;
            toaster.pop({
                type: 'Success',
                title: 'Bid Wizard',
                body: 'New Bid Created',
                showCloseButton: true
            });
        }, function(error) {
            toaster.pop({
                type: 'error',
                title: 'Bid Wizard',
                body: 'Problem Creating Bid',
                timeout: 0,
                fadein: 0,
                position: 'toast-top-full-width',
                showCloseButton: true
            });
        });
    };

    $scope.onCombinationSelect = function() {
        if(!this.combinationType) return;

        var data = $scope.combOptions.filter(item=> item.label === this.combinationType);
        $scope.bid.projectType = data[0].type;
        $scope.bid.geoLocation = data[0].location;
        $scope.bid.isCustom = data[0].isCustom;
        $scope.bid.userId = data[0].userId;

        if(this.combinationType == 'Service (Service)' && !data[0].isCustom) {
            $scope.codes = 'service';
            $scope.bid.plan_codes = [{'code': 'Service', 'quantity': 1}];
            $scope.plans = ['Service'];
            $scope.is_service = true;
        } else {
            $scope.codes = '';
            $scope.bid.plan_codes = [];
            $scope.plans = [];
            $scope.is_service = false;
        }
    }

    $scope.addOption = function() {
        if(!this.option) {
            toaster.pop('error', 'Add Option', 'Nothing entered.');
            return;
        }
        if(!this.option.number) {
            toaster.pop('error', 'Add Option', 'Number not entered.');
            return;
        }
        if(!this.option.name) {
            toaster.pop('error', 'Add Option', 'Name not entered.');
            return;
        }
        if(!this.option.plans) {
            toaster.pop('error', 'Add Option', 'No plan selected.');
            return;
        }

        if(!$scope.options.options) $scope.options.options = [];

        if ($scope.options.options && $scope.options.options.length > 0 &&
                $scope.options.options.filter(e => e.number == this.option.number).length != 0) {
            toaster.pop('error', 'Unique Code', 'Code Already Exists.');
            return;
        }

        var trades = [];
        var plans = [];

        for(var i=0; i<this.option.plans.length; i++) {
              plans.push(this.option.plans[i].code);
        }

        trades.push($scope.trades[0].name);

        var option = {
            number: this.option.number,
            name: this.option.name,
            description: this.option.description,
            trades: trades,
            plans: plans
        }

        if(!$scope.options_created) {
            var new_option = new Options({
                bid_id: $scope.bid._id,
                options: option
            });

            new_option.$save(function(success) {
                success.bid_date_requested = new Date(success.bid_date_requested);
                success.project_start_date = new Date(success.project_start_date);
                $scope.options = success;
                $scope.options_created = true;
                toaster.pop('success', 'Bid Option', 'Database updated.');
            }, function(error) {
                toaster.pop('error', 'Bid Option', error);
                return;
            });
        } else {
            $scope.options.options.push(option);

            $scope.options.$update(function(success) {
                //$scope.options = success.options;
                toaster.pop('success', 'Bid Option', 'Database updated.');
            }, function(error) {
                toaster.pop('error', 'Bid Option', error);
                return;
            });
        }

        this.option.number =
        this.option.name =
        this.option.description = 
        this.option.trades =
        this.option.plans = '';
    };

    $scope.fileSelected = function() {
        var lines, data;
        
        lines = this.$parent.fileContent.split('\n');
        var errors = false;
        var my_options = [];

        _.each(lines, function(l, lineNumber) {
            if(lineNumber !== 0) { //skip the first line
                data = l.split(',');

                if(angular.isArray(data[3])) {
                    toaster.pop('error', 'File Error', 'Cannot have multiple trades');
                    return;
                }

                if(my_options.filter(e => e.number == data[0]).length == 0) {
                    my_options.push({
                        number: data[0],
                        name: data[1],
                        description: data[2],
                        trades: $scope.user.trade[0],
                        plans: (angular.isArray(data[4]))?data[4].split(';'):data[4]
                    });
                } else {
                    errors = true;
                    toaster.pop('error', 'Option Number Error',
                        'Must have unique option numbers');
                    return;
                }
            }
        });

        _.remove(my_options, function(opt) {
            return opt.number === '';
        });

        delete this.$parent.fileContent;
        if(!errors) {
            if(!$scope.options_created) {
                var new_option = new Options({
                    bid_id: $scope.bid._id,
                    options: my_options
                });

                new_option.$save(function(success) {
                    success.bid_date_requested = new Date(success.bid_date_requested);
                    $scope.options = success;
                    $scope.options_created = true;
                    toaster.pop('success', 'Bid Option', 'Database updated.');
                }, function(error) {
                    toaster.pop('error', 'Bid Option', error);
                    return;
                });
            } else {
                //only add options we don't already have
                _.each(my_options, function(opt) {
                    var inlist = $filter('filter')($scope.options.options, {
                        'number': opt.number}, true);

                    if(inlist.length === 0) {
                        $scope.options.options.push(opt);
                    }
                });
                //$scope.options.options = my_options;

                $scope.options.$update(function(success) {
                    //$scope.options = success.options;
                    toaster.pop('success', 'Bid Option', 'Database updated.');
                }, function(error) {
                    toaster.pop('error', 'Bid Option', error);
                    return;
                });
            }
        }
    };

    $scope.ConvertToCSV = function(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = 'number, name, description, trades, plans';
        str += '\r\n';

        for(var i=0; i<array.length; i++) {
            str += array[i].number + ', ' + array[i].name + ', ' + array[i].description + ',';
            for(var j=0; j<array[i].trades.length; j++) {
                str += array[i].trades[j];

                if(j<array[i].trades.length-1)
                    str += '; ';
            }
            str += ', ';

            for(var j=0; j<array[i].plans.length; j++) {
                str += array[i].plans[j];

                if(j<array[i].plans.length-1)
                    str += '; ';
            }
            str += '\r\n';
        }

        return str;
    };

    $scope.exportFile = function() {
        var dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertToCSV($scope.options.options));
        var link = document.createElement('a');
      
        angular.element(link)
            .attr('href', dataUrl)
            .attr('download', 'bid_options.csv'); // Pretty much only works in chrome
      
        link.click();
    };

    $scope.deleteAll = function() {
        $scope.options.options = [];
        $scope.options.$update(function(success) {
            //$scope.options = success.options;
            toaster.pop('success', 'Bid Option', 'Database updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Option', error);
            return;
        });
    };

    $scope.removeOption = function(idx) {
        $scope.options.options.splice(idx, 1);
        $scope.options.$update(function(success) {
            //$scope.options = success.options;
            toaster.pop('success', 'Bid Option', 'Database updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Option', error);
            return;
        });
    };

    $scope.addPlanCodes = function(codes){
        if(!codes) return;
        var letterNumber = /^[0-9a-zA-Z]+$/;
        var goodInput = true;

        var array = codes.split(',');
        var removed = []
        for(var i=0; i<array.length; i++) {
            //remove any white space and make upper case
            array[i] = array[i].trim().replace(/\s/g, '').toUpperCase();
            //check for only alphanumeric
            if(!array[i].match(letterNumber)) {
                removed.push(array[i]);
            }
            //check for duplicates already saved
            if($scope.plans.indexOf(array[i]) !== -1) {
                removed.push(array[i]);
            }
        }

        if(removed.length > 0) {
            //notify the user of code issues
            _.each(removed, function(item) {
                if(item != '') {
                    toaster.pop('warning', 'Code Not Included', item);
                } else {
                    toaster.pop('warning', 'Code Not Included', 'Empty Code String');
                }
            });
        }

        for(var i=0; i<array.length; i++) {
            //One final check to make sure we don't include an empty string
            if(array[i] != '') {
                if($scope.plans.indexOf(array[i]) === -1) {
                    $scope.bid.plan_codes.push({
                        'code': array[i],
                    });
                    $scope.plans.push(array[i]);
                }
            }
        }

        this.codes = null;
    };

    $scope.removePlanCode = function(index) {
        $scope.bid.plan_codes.splice(index, 1);
    };

    $scope.submitBid = function(selected) {
        if($scope.processForm(selected) === -1) return;

        if(!$scope.bid.bid_date_requested) {
            alert('Return Date not set');
            return;
        }
        
        if(!$scope.bid.project_name) {
            alert('Please specify a project name');
            return;
        }

        if($scope.bid.bidding_trades.length === 0) {
            alert('No bidding trades selected');
            return;
        }

        if($scope.bid.bidding_trades.length === 0) {
            alert('Please select project combination');
            return;
        }

        if(!$scope.bid.projectType || !$scope.bid.geoLocation) {
            alert('Select a project combination type');
            return;
        }

        if($scope.bid.project_type === 'single') {
            if($scope.bid.plan_codes === 0) {
                alert('You must add at least one plan code for a single family project');
                return;
            }
        }

        // if($scope.bid.project_type === 'multi' || $scope.bid.project_type === 'commercial') {
        //     if($scope.bid.project_plan.multi.interior.length === 0) {
        //         alert('You must specify at least one interior plan code');
        //         return;
        //     }

        //     if($scope.bid.project_plan.multi.exterior.length === 0) {
        //         alert('You must specify at least one exterior plan code');
        //         return;
        //     }
        // }

        var promises = [];

        $scope.saved_bid_trades.forEach(function(trade) {
            var deferred = $q.defer();
            var inlist = $filter('filter')($scope.bid.bidding_trades, {'trade': trade.trade}, true);

            if(inlist.length === 0) return;
            var tcode = tradeCodeService.getCode(trade.trade);
            var bidType = $scope.bid.isCustom || false;
            var mainAccount = $scope.bid.userId || '';
            Subtasks.query(
                {
                    'subtask_trade': tcode,
                    'type': 'syncSubtask',
                    'projectType':$scope.bid.projectType,
                    'geoLocation': $scope.bid.geoLocation,
                    'isCustom': bidType,
                    'userId': mainAccount
                }, function(subtasks) {
                bidService.attachTaskList(trade, subtasks, $scope.bid.projectType, $scope.bid.geoLocation, tcode, bidType, mainAccount).then(function(results) {
                    deferred.resolve(results);
                });
            });

            promises.push(deferred.promise);
        });

        $q.all(promises).then(function(results) {
            if($scope.bid.geoLocation == 'Service' && 
                $scope.bid.projectType == 'Service') {
                //attach service task to task_list
                $scope.updateBidsTaskList(results, function(res) {
                    console.log(res);
                    let subtasks = $filter('filter')($scope.trade.subtasks, {
                        'projectType': 'Service', 'geoLocation': 'Service'}, true);

                    let update = true;
                    if(subtasks.length == 1) {
                        res[0].task_list[0].subtasks[0] = subtasks[0];
                        res[0].task_list[0].subtasks[0]._id = 0;
                        let obj = {
                            equipment: 0,
                            labor: 0,
                            materials: 0,
                            plan_code: "Service",
                            subtasks: [{
                                bid_hours: 0,
                                equipment: [],
                                hours_allowed: 0,
                                labor: 0,
                                materials: [],
                                quantity: 0,
                                task_id: 0,
                            }],
                            task_id: 1,
                        }

                        if(res[0].bid.length == 0) {
                            res[0].bid.push(obj);
                        } else if(res[0].bid.length == 1) {
                            res[0].bid[0] = obj;
                        } else {
                            update = false;
                            toaster.pop('error', 'Trade Subtask Bid Error', 'There is already a bid for the service subtask');
                        }

                        if(update) {
                            $scope.bid.bidding_trades[0] = res[0];
                            //Trades record $scope.builder
                            let code = tradeCodeService.getCode($scope.trade.trade);
                            bidService.acceptServiceBid(
                                $scope.main_account_id,
                                $scope.bid,
                                code
                            );

                            $location.path('trades/bids');
                        }
                    } else {
                        toaster.pop('error', 'Trade Subtask Error', 'Did not find the service subtask');
                    }
                });
            } else {
                $scope.updateBidsTaskList(results, function(res) {
                    $scope.bid.bid_status = 'submitted';
                    $scope.bid.$update(function(results) {
                          $location.path('trades/bids');
                    }, function(error) {
                        toaster.pop('error', 'Bid Update', 'Could not update the database');
                        return;
                    });
                });
            }
        });
    };

    //step through all bidding_trades and save the task_list
    //once all are saved, return so the main bid can update
    $scope.updateBidsTaskList = function(items, callback) {
        var promises = [];

        items.forEach(function(item) {
            var deferred = $q.defer();
            console.log('saving a trade bid');
            item.$update(function(success) {
                console.log('trade bid saved');
                deferred.resolve(success);
            }, function(error) {
                toaster.pop('error', 'Problem Saving a Trades Bid');
            });

            promises.push(deferred.promise);
        });

        $q.all(promises).then(function(results) {
            callback(results);
        });
    };

    $scope.onSelect = function(){
        if(!$scope.bid_name || !$scope.bid_name._id) return;

        $scope.saved_bid_trades = [];
        $scope.selectedTrade = [];
        
        userService.getMainAccountId($scope.user.username).then(function(result) {
            Trades.query({'main_account_id': result}, function(trades) {
                $scope.trade = trades[0];
                $scope.builder = trades[0];

                bidQueryService.getById($scope.bid_name._id).then(function(bid) {
                    $scope.bid = bid[0];

                    // check for selected customers
                    $scope.selCustomer = !_.isEmpty($scope.bid.selCustomer) ? $scope.bid.selCustomer.name : '';
                    if (!_.isEmpty($scope.bid.selCustomer) && $scope.bid['project_manager_info'] && $scope.bid.selCustomer.contacts.projectManagers.length) {
                        const foundManager = $scope.bid.selCustomer.contacts.projectManagers.filter(item => item.name === $scope.bid['project_manager_info']['name']);
                        if (foundManager.length) {
                            $scope.selManager = foundManager[0].name;
                        }
                    }

                    if (!_.isEmpty($scope.bid.selCustomer) && $scope.bid['purchasing_agent_info'] && $scope.bid.selCustomer.contacts.purchasingAgents.length) {
                        const foundAgent = $scope.bid.selCustomer.contacts.purchasingAgents.filter(item => item.name === $scope.bid['purchasing_agent_info']['name']);
                        if (foundAgent.length) {
                            $scope.selPAgent = foundAgent[0].name;
                        }
                    }

                    //hardcode project type to single for now
                    $scope.bid.project_type = 'single';

                    if($scope.bid.plan_codes.length) {
                        for(var i=0; i<$scope.bid.plan_codes.length; i++) {
                            $scope.plans.push($scope.bid.plan_codes[i].code);
                        }
                    }

                    $scope.project_manager = $scope.bid.project_manager;

                    if(!$scope.bid.bid_date_requested) $scope.bid.bid_date_requested = new Date();

                    $scope.division = $scope.bid.division;
                    $scope.bid.bid_date_requested = new Date($scope.bid.bid_date_requested);
                    $scope.bid.project_start_date = new Date($scope.bid.project_start_date);

                    if($scope.bid.trades.length == 0) {
                        $scope.new_manager = $scope.managers[0];
                        $scope.new_foreman = $scope.foreman_users[0];
                        $scope.bid.trades.push({
                            'name': $scope.builder.name,
                            'main_username': $scope.main_account_id,
                            'manager': { 
                                'name': $scope.managers[0].name,
                                'username': $scope.managers[0].username,
                                'phone': $scope.managers[0].phone,
                                'email': $scope.managers[0].email
                            },
                            'foreman': {
                                'name': $scope.foreman_users[0].name,
                                'username': $scope.foreman_users[0].username,
                                'phone': $scope.foreman_users[0].phone,
                                'email': $scope.foreman_users[0].email
                            }
                        });
                    } else {
                        if($scope.bid.trades[0].manager) {
                            let manager = $filter('filter')($scope.managers, {
                                'username': $scope.bid.trades[0].manager.username}, true)[0];
                            $scope.new_manager = manager;
                        } else {
                            $scope.new_manager = $scope.managers[0];
                        }
                        
                        if($scope.bid.trades[0].foreman) {
                            let foreman = $filter('filter')($scope.foreman_users, {
                                'username': $scope.bid.trades[0].foreman.username}, true)[0];
                            $scope.new_foreman = foreman;
                        } else {
                            $scope.new_foreman = $scope.foreman_users[0];
                        }
                    }

                    Options.query({'bid_id': $scope.bid._id}, function(options) {
                        if(options.length === 1) {
                            $scope.options = options[0];
                            $scope.options_created = true;
                        } else if(options.length > 1) {
                            toaster.pop('error', 'Bid Options', 'Too many options from database');
                            return;
                        } 
                    });

                    TradeBids.query({'bid_id': $scope.bid._id}, function(trades) {
                        //if no trade bid then create one for us only
                        if(trades.length === 0) {
                            var saved = new TradeBids({
                                trade: $scope.user.trade[0],
                                bid_id: $scope.bid._id,
                                name: $scope.trade.main_account_id.name,
                                username: $scope.trade.main_account_id.username,
                                email: $scope.trade.email,
                                phone: $scope.trade.phone
                            });

                            saved.$save(function(returned) {
                                returned.bid_date_requested = new Date(returned.bid_date_requested);
                                returned.project_start_date = new Date(returned.project_start_date);
                                $scope.saved_bid_trades.push(returned);
                                returned.on = true;
                                $scope.toggleTrade(returned);
                            }, function(error) {
                                toaster.pop('error', 'Saving Trade Bids', 'Problem with saving the current bid trade ' + returned.name);
                            });
                            
                        } else if(trades.length === 1) {
                            $scope.saved_bid_trades = angular.copy(trades);
                            trades[0].on = true;
                            $scope.toggleTrade(trades[0]);

                            $scope.bid.bidding_trades.forEach(function(bid) {
                                var item = $filter('filter')($scope.trades, {'name': bid.trade}, true);
                                if(item.length === 1) {
                                    item[0].on = true;
                                } else {
                                    item[0].on = false;
                                }
                                
                                $scope.selectedTrade.push(bid);
                            });
                        } else {
                            toaster.pop('error', 'Bid Database Error', 'Contact Admin');
                        }
                        if($scope.bid.projectType && $scope.bid.geoLocation) {
                            var data = $scope.combOptions.filter(item=> (item.type === $scope.bid.projectType && item.location === $scope.bid.geoLocation));
                            if(data.length) { 
                                $scope.combinationType = data[0].label; 

                                if($scope.combinationType == 'Service (Service)' && !data[0].isCustom) {
                                    if($scope.bid.plan_codes.length != 1 && $scope.bid.plan_codes[0].code != 'Service') {
                                        $scope.bid.plan_codes = [{'code': 'Service', 'quantity': 1}];
                                    }
                                    $scope.is_service = true;
                                } else {
                                    $scope.is_service = false;
                                }
                            }
                        }
                    });
                });
            });
            // get customer list
            Customers.query({'isDeleted': false, 'userId': result}, function(results) {
                $scope.customers = results;
            });
        });
    };

    $scope.bid = BidWizardEdit.get();

    if($scope.bid) {
        $scope.new_bids.push($scope.bid);
        $scope.bid_name = {
            _id: $scope.bid._id,
            bid_name: $scope.bid.bid_name,
            bid_status: $scope.bid.bid_status
        }

        $scope.onSelect();
    }

    $scope.setProjectManager = function(item) {
        $scope.project_manager = item;
    };

    $scope.setPurchasingAgent = function(item) {
        $scope.bid.purchasing_agent = item;
        $scope.bid.purchasing_agent_info = item;
    };

    $scope.processForm = function(selected) {
        if(!$scope.bid || !$scope.bid._id) {
            toaster.pop({
                type: 'error',
                title: 'Bid Selection',
                body: 'Please Select a Bid!',
                showCloseButton: true
            });

            return -1;
        }

        $scope.bid.project_manager = $scope.project_manager;

        $scope.bid.$update(function(results) {
            results.bid_date_requested = new Date(results.bid_date_requested);
            results.project_start_date = new Date(results.project_start_date);
            if(results.projectType && results.geoLocation) {
                var data = $scope.combOptions.filter(item=> (item.type === results.projectType && item.location === results.geoLocation));
                if(data.length) { $scope.combinationType = data[0].label; }
            }
            toaster.pop({
                type: 'success',
                title: 'Bid Update',
                body: 'Current bid ' + $scope.bid.bid_name + ' updated.'
            });
        }, function(error) {
            toaster.pop({
                type: 'error',
                title: 'Bid Update',
                body: 'Current bid ' + $scope.bid.bid_name + ' not update.'
            });
            return;
        });
    };

    $scope.setEditId =  function(pid) {
       $scope.editId = pid;
    };

    $scope.states = [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
    ];

    $scope.toggleTrade = function(item) {
        var inlist = $filter('filter')($scope.saved_bid_trades, {'trade': item.name}, true);
        if(item.on) {
            if(inlist.length > 0) {
                $scope.selectedTrade = [];
                for(var i=0; i<inlist.length; i++) {
                    $scope.bid.bidding_trades.push(inlist[i]);
                    $scope.selectedTrade.push(inlist[i]);
                }
            }
        } else {
            for(var i=$scope.bid.bidding_trades.length-1; i>=0; i--) {
                if($scope.bid.bidding_trades[i].trade === item.name) {
                    $scope.bid.bidding_trades.splice(i, 1);
                }
            }
        }
    };

    $scope.updateTradeUsers = function(selectedTrade) {
        for(var i=$scope.bid.bidding_trades.length-1; i>=0; i--) {
            if($scope.bid.bidding_trades[i].trade === selectedTrade[0].trade[0])
              $scope.bid.bidding_trades.splice(i, 1);
        }

        for(var i=0; i<selectedTrade.length; i++) {
            var inlist = $filter('filter')($scope.saved_bid_trades, {'username': selectedTrade[i].username}, true);
            if(inlist.length === 1)
              $scope.bid.bidding_trades.push(inlist[0]);
        }

        $scope.bid.$update(function(results) {
            results.bid_date_requested = new Date(results.bid_date_requested);
            results.project_start_date = new Date(results.project_start_date);
            toaster.pop({
                type: 'success',
                title: 'Bid Update',
                body: 'Current bid ' + $scope.bid.bid_name + ' updated.'
            });
        }, function(error) {
            toaster.pop({
                type: 'error',
                title: 'Bid Update',
                body: 'Current bid ' + $scope.bid.bid_name + ' not update.'
            });
            return;
        });
    };

    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };

    $scope.acceptTradeEdits = function() {
        console.log(this);

        //assume one trade at this time
         var trade = $scope.bid.trades[0];

        if(this.new_foreman && this.new_foreman.name) {
            trade.foreman = {
                email: this.new_foreman.email,
                name: this.new_foreman.name,
                phone: this.new_foreman.phone,
                username: this.new_foreman.username
            }
        }

        if(this.new_manager && this.new_manager.name) {
            trade.manager.email = this.new_manager.email;
            trade.manager.name = this.new_manager.name;
            trade.manager.phone = this.new_manager.phone;
            trade.manager.username = this.new_manager.username;
        }

        $scope.bid.$update(function(results) {
            results.bid_date_requested = new Date(results.bid_date_requested);
            results.project_start_date = new Date(results.project_start_date);
        }, function(error) {
            toaster.pop('error', 'Bid Update', 'Could not update the database');
            return;
        });
    };

    $scope.acceptManagementCombinationEdits = function() {
        console.log(this);
    };

    $scope.editManagementCombination = function(trade, combo) {
        $scope.available_managers = [];
        $scope.available_tasks = [];
        $scope.can_modify_trade = true;
    };

    $scope.addManagementCombination = function(trade) {
        console.log(trade);
        console.log($scope);
    };

    $scope.removeManagementCombination = function(trade, idx) {
        console.log(trade);
        console.log($scope);
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/trades/public/controllers/tradeBidWizard.js